import { TextField } from "@mui/material";
import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, greyMui, rydeColors } from "@ryde/theme";

export const TableSettingsContent = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "table-settings-content",
})`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const DragItemsContainerStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "drag-items-container",
})`
  padding: 20px 10px 10px 24px;

  .table-setting-drawer__title {
    font-size: 16px;
    color: ${blueGreyMui._500};
    margin-bottom: 5px;
  }

  &.table-setting-drawer__drag-items-container_inactive {
    border-top: 1px solid ${greyMui._300};
  }
`;

export const TableSettingsSearchFieldStyled = styled(TextField)`
  display: flex;
  align-items: center;
  padding-inline: 15px;
  padding-block: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid ${greyMui._300};

  &.MuiFormControl-root {
    width: 100%;
  }

  & .MuiOutlinedInput-root {
    padding: 0;
  }

  & .MuiOutlinedInput-inputMultiline {
    padding: 0;
  }

  & .MuiOutlinedInput-input {
    padding: 0;
    color: ${rydeColors.grey};
  }

  & .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  & .MuiInputBase-adornedEnd {
    padding-inline-start: 0;

    .MuiIconButton-edgeEnd {
      padding: 0px;
    }
  }
`;
